import React from 'react';
import {
    ShippingText,
    NoInventoryShippingDiv,
    Div,
} from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { sizes } from 'src/styles/Media.styled';
import { detectDeviceInfo } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const UnidRodCannotModifyNotification = ({ onClose, isFromCart }) => {
    // eslint-disable-next-line no-unused-vars
    const { deviceName, deviceType, browser } = detectDeviceInfo();
    const {t} = useTranslation();
    return (
        <>
            <Popup
                title={
                    isFromCart
                        ? t('scheduleSurgery.surgery.notifications.UnidRodCannotModifyNotification.popupTitle')
                        : t('scheduleSurgery.surgery.notifications.UnidRodCannotModifyNotification.popupTitle1')
                }
                onClose={onClose}
                img={AlertCircleOutline}
                emptyCartWidth={'38%'}
                ipadwidth={'45%'}
                portraitWidth={'55%'}
                iconWidth={
                    deviceType === 'Phone' ? '43px' : '32px'
                }
                mobileWidthB33Popup={'97%'}
                mbIconMarginRight={'-10px'}
                mobileWidth={true}
                alignItemsMob={'start'}
                id={'surgery-notification-unidRodCannotModifyNotification-popup'}
            >
                <NoInventoryShippingDiv
                    height={window.innerWidth > sizes.mobileDevice && '120px'}
                    mobileWidth={'340px'}
                >
                    <ShippingText
                        height={
                            window.innerWidth > sizes.mobileDevice && '75px'
                        }
                        mobileWidth={'320px'}
                    >
                        {isFromCart
                            ? t('scheduleSurgery.surgery.notifications.UnidRodCannotModifyNotification.contactText')
                            : t('scheduleSurgery.surgery.notifications.UnidRodCannotModifyNotification.contactText1')}
                    </ShippingText>
                    <Div position={'relative'}>
                        <Button
                            id={'surgery-notifications-unidrodcannotmodifynotification-okbutton'}
                            show={true}
                            width={'80px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                            // primary={true}
                            margin={'5px 0px 5px 5px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                           {t('scheduleSurgery.surgery.notifications.UnidRodCannotModifyNotification.okButton')}
                        </Button>
                    </Div>
                </NoInventoryShippingDiv>
            </Popup>
        </>
    );
};

export default UnidRodCannotModifyNotification;
